// The master list of all opened dialogs.
// This keeps track of opened dialogs and the order in which they were opened and allows us to show only a single "::backdrop" element for the top-most open dialog. When that top-most dialog is closed, the next most recently opened dialog is promoted to "top-most" and its ::backdrop is shown.

const updateMaximalBackdropEventName = 'aha-dialog:updateMaximalBackdrop';

export function notifyOfBackdropChange() {
  window.dispatchEvent(new CustomEvent(updateMaximalBackdropEventName));
}

// Set both prop and attribute so the change is instantaneous, otherwise can cause undesired flash of style as the external attribute will not match the internal state until Stencil flushes state changes to the DOM a microsecond after the prop is set.
function setMaximal(elem: HTMLAhaDialogElement, value: boolean) {
  elem.maximal = value;
  value ? elem.setAttribute('maximal', '') : elem.removeAttribute('maximal');
}

class EnhancedSet extends Set {
  constructor() {
    super();
  }

  add(val: HTMLAhaDialogElement) {
    // Handle the scenario where the dialog may need to be brought to the front when it is already opened.
    if (this.has(val)) this.delete(val);

    const arr = Array.from(this);
    const oldMaximal = arr[arr.length - 1];
    if (oldMaximal) setMaximal(oldMaximal, false);
    setMaximal(val, true);
    super.add(val);
    notifyOfBackdropChange();
    return this;
  }

  delete(val: HTMLAhaDialogElement) {
    super.delete(val);
    const arr = Array.from(this);
    const newMaximal = arr[arr.length - 1];
    setMaximal(val, false);
    if (newMaximal) setMaximal(newMaximal, true);
    notifyOfBackdropChange();
    return true;
  }
}

export const OpenedDialogs = new EnhancedSet() as Set<HTMLAhaDialogElement>;

function handleBackdropChange() {
  const maximalBackdropElem = Array.from(OpenedDialogs)
    .reverse()
    .find((dialog: any) => !dialog.hideBackdrop);

  OpenedDialogs.forEach((dialog: HTMLAhaDialogElement) => {
    if (dialog === maximalBackdropElem) {
      dialog.dataset.backdrop = '';
    } else {
      delete dialog.dataset.backdrop;
    }
  });
}

window.addEventListener(updateMaximalBackdropEventName, handleBackdropChange);
